import campaigns from '@/campaigns/store';
import dashboard from '@/dashboard/store';
import integrations from '@/integrations/store';
import monsterleads from '@/monsterleads/store';
import notifications from '@/notifications/store';
import omu from '@/university/store';
import plugins from '@/store/modules/plugins';
import settings from '@/settings/store';
import tabs from '@/store/modules/tabs';
import templates from '@/templates/store';
import wizard from '@/wizard/store';
import wp from '@/store/modules/wordpress';
import playbooks from 'optinmonster-js-library/src/vue/playbooks/store';

export default {
	campaigns,
	dashboard,
	integrations,
	monsterleads,
	notifications,
	omu,
	plugins,
	settings,
	tabs,
	templates,
	wizard,
	wp,
	playbooks,
};
